import { Button, Container, Grid2 as Grid, Paper } from "@mui/material"
import { Link, useLocation, useParams } from "react-router-dom"
import { ProjectTitle } from "../../components/Titles/ProjectTitle"
import { Body, Label } from "../../components/Typography/Typography"
import { useNexusNavigate } from "../../hooks/useNexusNavigate"
import { useTitle } from "../../hooks/useTitle"
import { ConfirmationRoutes, routes } from "../../routing/NexRoutes"

type ConfirmationMessageType = {
    label: string
    body: string
    callToAction: string
    navigateFun: () => void
}

export const Confirmation = () => {
    const nexusNav = useNexusNavigate()

    const { confirmationRoute } = useParams()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const projectNumber = queryParams.get("projectNumber")
    const entityName = queryParams.get("entityName")

    let routeDetails: ConfirmationMessageType

    switch (confirmationRoute) {
        case ConfirmationRoutes.MISSION_SUBMITTED:
            routeDetails = {
                label: "Submitted Successfully",
                body: "Mission submitted. Would you like to submit another sensor file?",
                callToAction: "Submit Another",
                navigateFun: () => nexusNav.missionUpload(projectNumber!),
            }
            break
        case ConfirmationRoutes.MISSION_EDITED:
            routeDetails = {
                label: "Updated Successfully",
                body: "Mission updated. Would you like to edit another?",
                callToAction: "Edit Another",
                navigateFun: () => nexusNav.missionSelect(projectNumber!),
            }
            break
        case ConfirmationRoutes.MISSION_REVIEWED:
            routeDetails = {
                label: "Review Submitted Successfully",
                body: "Mission reviewed. Would you like to review another?",
                callToAction: "Review Another",
                navigateFun: () => nexusNav.missionSelect(projectNumber!),
            }
            break
        case ConfirmationRoutes.FLIGHTPLAN_SUBMITTED:
            routeDetails = {
                label: "Submitted Successfully",
                body: "Flightplan submitted. Would you like to submit another?",
                callToAction: "Submit Another",
                navigateFun: () => nexusNav.flightplanUpload(projectNumber!),
            }
            break
        case ConfirmationRoutes.FLIGHTPLAN_EDITED:
            routeDetails = {
                label: "Updated Successfully",
                body: "Flightplan updated. Would you like to edit another?",
                callToAction: "Edit Another",
                navigateFun: () => nexusNav.flightplanEdit(projectNumber!),
            }
            break
        case ConfirmationRoutes.PROJECT_EDITED:
            routeDetails = {
                label: "Updated Successfully",
                body: "Project updated. Would you like to continue editing?",
                callToAction: "Edit Again",
                navigateFun: () => nexusNav.editProject(projectNumber!),
            }
            break
        case ConfirmationRoutes.DATA_RECEIPT_SUBMITTED:
            routeDetails = {
                label: "Submitted Successfully",
                body: "Data receipt submitted. Would you like to submit another data receipt?",
                callToAction: "Submit Another",
                navigateFun: nexusNav.createDataReceipt,
            }
            break
        case ConfirmationRoutes.DATA_RECEIPT_UPDATED:
            routeDetails = {
                label: "Updated Successfully",
                body: "Data receipt updated. Would you like to update another data receipt?",
                callToAction: "Update Another",
                navigateFun: nexusNav.dataReceiptTable,
            }
            break
        default:
            throw new Error(`Unexpected confirmation route: ${confirmationRoute}`)
    }

    const { label, body, callToAction, navigateFun } = routeDetails

    useTitle(`Confirmation - ${label}`)

    return (
        <Container maxWidth="md" sx={{ py: 10 }}>
            <Paper sx={{ p: 2 }}>
                {projectNumber != null && <ProjectTitle projectNumber={projectNumber} />}

                <Label gutterBottom="sm">
                    {entityName ?? ""} {label}
                </Label>
                <Body gutterBottom="lg">{body}</Body>

                <Grid container spacing={2}>
                    <Grid>
                        <Button component={Link} to={routes.home} variant={"outlined"} color="primary" size="large">
                            Return Home
                        </Button>
                    </Grid>
                    <Grid>
                        <Button onClick={navigateFun} variant="contained" color="primary" size="large">
                            {callToAction}
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    )
}
